import formatRupiah from "../../utils/FormatRupiah";
import formatTanggal from "../../utils/FormatTanggal";


const statusLabelMap = {
  'CRA': 'Credit Review Analis',
  'APPV-1': 'APPROVAL 1',
  'APPV-2': 'APPROVAL 2',
  'APPV-3': 'FINAL APPROVE',
};

 

const columns = [
  // {
  //   title: "Tanggal",
  //   dataIndex: "tgl",
  //   key: "tgl",
  //   render: (text) => <p>{formatTanggal(text)}</p>,
  // },
  {
    title: "Application ID",
    dataIndex: "application_id",
    key: "application_id",
    // width: 200,
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NAMA",
    dataIndex: "nama",
    key: "nama",
    // render: (text) => <a>{text}</a>,
  },
  {
    title: "NIK",
    dataIndex: "nik",
    key: "nik",
  },
  {
    title: "MARITAL STATUS",
    dataIndex: "statuspernikahan",
    key: "statuspernikahan",
    // render: (text) => (
    //   <a
    //     href={text}
    //     // href="https://www.google.com"
    //     target="_blank"
    //     rel="noreferrer"
    //     style={{ color: "blue", textDecoration: "underline" }}
    //   >
    //     Menikah
    //   </a>
    // ),
  },
   {
    title: "NOMOR HP",
    dataIndex: "nohp",
    key: "nohp",
  },
   {
    title: "APPROVAL DATE",
    dataIndex: "created_date",
    key: "created_date",
    render: (text) => <p>{formatTanggal(text)}</p>,
  },
  //   {
  //   title: "NOMOR TELEPON",
  //   dataIndex: "nomortelepon",
  //   key: "nomortelepon",
  // },
  // {
  //   title: "KATEGORI PEMOHON",
  //   dataIndex: "katpemohon",
  //   key: "katpemohon",
  // },
 {
  title: "STATUS",
  dataIndex: "status",
  key: "status",
  render: (text) => {
    const cleaned = text?.replace(/\s+/g, ''); // hilangkan spasi jika ada

    const statusLabelMap = {
      'CRA': 'Credit Review Analis',
      'APPV-1': 'APPROVAL 1',
      'APPV-2': 'APPROVAL 2',
      'APPV-3': 'APPROVAL 3',
      'FA': 'FINAL APPROVE',
      'REJECTED': 'REJECTED'
    };

  const statusColorMap = {
  'CRA': '#ff4d4f',      // Merah terang (butuh perhatian)
  'APPV-1': 'rgba(255, 102, 0, 1)',   // Kuning (review/pertimbangan)
  'APPV-2': '#ffff00',   // Hijau muda (positif, lanjut)
  'APPV-3': '#00ff00',   // Hijau tua (final, disetujui)
  'FA': '#0000ff',
  'REJECTED': '#ff4d4f'

};


const label = statusLabelMap[cleaned] || text;
const bgColor = statusColorMap[cleaned] || '#d9d9d9';
    // const textColor = cleaned === 'APPV-3' ? '#fff' : '#000' || 'APPV-2' ? '#fff' : '#000'; // biar hijau tua tetap kebaca
    // const textColor = cleaned === 'APPV-2' ? '#000' : '#fff' || cleaned === 'APPV-3' ? '#000' : '#fff';

const darkTextStatuses = ['APPV-2', 'APPV-3'];
const textColor = darkTextStatuses.includes(cleaned) ? '#000' : '#fff';


 
    return (
      <span
  style={{
    backgroundColor: bgColor,
    color: textColor,
    padding: '4px 10px',
    borderRadius: '4px',
    fontWeight: 'bold',
    fontSize: '12px',         // ukuran font lebih kecil
    display: 'inline-block',  // penting agar width bekerja
    width: '150px',           // sesuaikan lebar sesuai kebutuhan
    textAlign: 'center',      // agar teks di tengah
  }}
>
  {label}
</span>

    );
  },
}


  // {
  //   title: "STATUS",
  //   dataIndex: "is_survey",
  //   key: "is_survey",
  //   render: (text) => (
  //     <p className="capitalize font-semibold">
  //       {text == 1 ? "Survey In Progress" : "Rejected"}
  //     </p>
  //   ),
  // },

];


export { columns };
